import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import store from './app/store/index'
// import { registerLicense } from "@syncfusion/ej2-base";
// import './index.css';
import App from './App';

// registerLicense(
//     // "Ngo9BigBOggjHTQxAR8/V1JHaF5cWWdCfUx1RHxbf1x2ZFFMYlxbRnBPMyBoS35RcEVgW3tedHZVRGZUWUV3VEFe"
//     // "Ngo9BigBOggjHTQxAR8/V1JHaF5cWWdCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWXxcdXRWRmNfU0R2W0VWYEo="
//     "Ngo9BigBOggjHTQxAR8/V1NBaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWXxcdXRWRmReWUZ+XkRWYUw="
//     // "09AKhCRwhEnEPuqaNOQ07K9Xfq9495ns6WmAGJU9bRuBgq2JY0LFr1e0DZ5YsUyX_pBD6qbTr5BBH_klVsF5Qyu8JOo0hNmpUX3mf5hboQeHIgDjbTBZTHIkoTv1p_WVOZ"
//   );

// import 'bootstrap/dist/css/bootstrap.css';
// import './assets/scss/mdb-pro.scss';
// import '../node_modules/@syncfusion/ej2-base/styles/material.scss';
// import '../node_modules/@syncfusion/ej2-buttons/styles/material.scss';
// document.body.classList.add('e-small');
ReactDOM.render(
<Provider store={store}>
<App />
</Provider> 
, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();p
